<div class="rapport-xy-container">
    <igo-spinner [shown]="isLoading"></igo-spinner>
    <div id="divXYReport" *ngIf="rapportXyDto && !isLoading">
        <table class="container-for-copypaste-to-excel">
            <tr>
                <td>
                    <table>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.projection' | translate }}
                            </th>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.fuseau' | translate }}</th>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.nord' | translate }}</th>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.est' | translate }}</th>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.mtm' | translate }}</th>
                            <td>{{rapportXyDto.mtmFuseau}}</td>
                            <td>{{rapportXyDto.mtmNord}}</td>
                            <td>{{rapportXyDto.mtmEst}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.utm' | translate }}</th>
                            <td>{{rapportXyDto.utmFuseau}}</td>
                            <td>{{rapportXyDto.utmNord}}</td>
                            <td>{{rapportXyDto.utmEst}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.latitudeLongitude' | translate }}</th>
                            <td></td>
                            <td>{{rapportXyDto.latitude}}</td>
                            <td>{{rapportXyDto.longitude}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.dms' | translate }}</th>
                            <td></td>
                            <td>{{rapportXyDto.latitudeDMS}}</td>
                            <td>{{rapportXyDto.longitudeDMS}}</td>
                        </tr>
                    </table>
                    <br />

                    <table>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.territoireSousDelegationDeGestion' |
                                translate }}
                            </th>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.delegataire' | translate }}</th>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.subdelegataire' | translate }}</th>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.conventionDeGestionTerritoriale' |
                                translate }}
                            </th>
                            <td>{{rapportXyDto.conventionDeGestionTerritorialeDelegataire || 'Aucun'}}</td>
                            <td>{{rapportXyDto.conventionDeGestionTerritorialeSubdelegataire || 'Aucun'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.villegiatureAbriSommaireSableGravier' |
                                translate
                                }}
                            </th>
                            <td>{{rapportXyDto.villegiatureAbriSommaireSableGravierDelegataire || 'Aucun'}}</td>
                            <td>{{rapportXyDto.villegiatureAbriSommaireSableGravierSubdelegataire || 'Aucun'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.zoneDeRecreationPrincipaleParcRegional'
                                | translate
                                }}
                            </th>
                            <td>{{rapportXyDto.zoneDeRecreationPrincipaleParcRegionalDelegataire || 'Aucun'}}</td>
                            <td>{{rapportXyDto.zoneDeRecreationPrincipaleParcRegionalSubdelegataire || 'Aucun'}}</td>
                        </tr>
                    </table>
                    <br />

                    <table>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.parcRegional' | translate }}</th>
                            <td>{{rapportXyDto.parcRegional || 'Aucun'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.zoneAccessibleAuxPremiersRequerants' |
                                translate }}
                            </th>
                            <td>{{(rapportXyDto.zoneAccessibleAuxPremiersRequerants ? 'sigt.global.general.oui' :
                                'sigt.global.general.non') | translate}}</td>
                        </tr>
                    </table>
                    <br />

                    <table>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.domanialiteType' | translate }}</th>
                            <td>{{rapportXyDto.domanialiteType || 'Aucune'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.domanialiteAutorite' | translate }}
                            </th>
                            <td>{{rapportXyDto.domanialiteAutorite || 'Aucune'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.bdtq' | translate }}</th>
                            <td>{{rapportXyDto.bdtq || 'Aucune'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.bdta' | translate }}</th>
                            <td>{{rapportXyDto.bdta || 'Aucune'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.municipalite' | translate }}</th>
                            <td>@if(rapportXyDto.municipalite || rapportXyDto.municipaliteCode) {{{rapportXyDto.municipalite}} @if(rapportXyDto.municipaliteCode) {{{rapportXyDto.municipaliteCode}} -
                                {{rapportXyDto.municipaliteCodeDesignation}} }} @else {Aucune}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.regionAdministrative' | translate }}
                            </th>
                            <td>@if(rapportXyDto.regionAdministrative || rapportXyDto.regionAdministrativeCode) {{{rapportXyDto.regionAdministrative}} @if(rapportXyDto.regionAdministrativeCode) {({{rapportXyDto.regionAdministrativeCode}})}} @else {Aucune}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.typeDeTerritoire' | translate }}</th>
                            <td>{{rapportXyDto.typeDeTerritoire || 'Aucun'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.mrc' | translate }}</th>
                            <td>@if(rapportXyDto.mrc || rapportXyDto.mrcCode) {{{rapportXyDto.mrc}} @if(rapportXyDto.mrcCode) {({{rapportXyDto.mrcCode}})}} @else {Aucune}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.planDEauAProximite' | translate }}</th>
                            <td>@if(rapportXyDto.planDEau) {{{rapportXyDto.planDEau}} ({{rapportXyDto.planDEauDistance}} km)} @else {Aucun}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.numeroLotRenove' | translate }}</th>
                            <td>{{rapportXyDto.numeroLotRenove || 'Aucun'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.niveau1' | translate }}</th>
                            <td>@if(rapportXyDto.niveau1) {{{rapportXyDto.niveau1}} {{rapportXyDto.niveau1Type ? '(' + rapportXyDto.niveau1Type +
                                ')' : ''}}} @else {Aucun}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.niveau2' | translate }}</th>
                            <td>@if(rapportXyDto.niveau2) {{{rapportXyDto.niveau2}} {{rapportXyDto.niveau2Type ? '(' + rapportXyDto.niveau2Type +
                                ')' : ''}}} @else {Aucun}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.niveau3' | translate }}</th>
                            <td>@if(rapportXyDto.niveau3) {{{rapportXyDto.niveau3}} {{rapportXyDto.niveau3Type ? '(' + rapportXyDto.niveau3Type +
                                ')' : ''}}} @else {Aucun}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.zecReserveFauniquePourvoirie' |
                                translate }}</th>
                            <td>{{rapportXyDto.zecReserveFauniquePourvoirie ? rapportXyDto.zecReserveFauniquePourvoirie
                                 : 'Aucune'}}
                            </td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.airesProtegeesDuRegistre' | translate
                                }}</th>
                            <td>{{rapportXyDto.airesProtegeesDuRegistreCode || 'Aucune'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.uniteDAmenagement' | translate }}</th>
                            <td>{{rapportXyDto.uniteDAmenagementCode || 'Aucune'}}</td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.trDossierGDF' | translate }}</th>
                            <td>{{rapportXyDto.trDossierGDFRegion ? rapportXyDto.trDossierGDFRegion + ', ' +
                                rapportXyDto.trDossierGDFTerritoire + ', TR ' +
                                rapportXyDto.trDossierGDFNumeroTerritoire : 'Aucun' }}
                            </td>
                        </tr>
                    </table>
                    <br />

                    <table>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.pole' | translate }}</th>
                            <td>{{ rapportXyDto.pole ? rapportXyDto.pole + " (" + rapportXyDto.poleCode + ")" : "Aucun" }}
                            </td>
                        </tr>
                        <tr>
                            <th>{{ 'sigt.integration.sigtSpatialFilter.rapportXY.classeDEloignement' | translate }}</th>
                            <td>{{ rapportXyDto.classeDEloignement ? rapportXyDto.classeDEloignement + " (" +
                                rapportXyDto.classeDEloignementCode + ")" : "Aucune" }}</td>
                        </tr>
                    </table>

                </td>
            </tr>
        </table>
    </div>
    <div class="divPrint" *ngIf="rapportXyDto && !isLoading">
      <button mat-raised-button
          (click)="print()">{{'sigt.global.boutons.print' | translate}}</button>
    </div>
</div>
